import { Request } from 'shared/tools/request';

export const signIn = (email, password) =>
  Request.post('/api/auth/sign-in', {
    data: {
      email,
      password,
    },
  });
